export default "__VITE_ASSET__LL0o8D6d__"